import type Highcharts from "highcharts";

// repro: select a cycle where start == end
export default function fixGetTimeTicksWhenStartEqualEnd(H: typeof Highcharts) {
  H.wrap(
    H.Axis.prototype,
    "getTimeTicks",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (this: Highcharts.Axis, proceed: any, ...args: unknown[]) {
      const [_, start, end] = args;
      if (start === end) {
        // original implem won't converge...
        return [];
      }
      return proceed.apply(this, args);
    },
  );
}
